import React from "react";

const EventDetailItem: React.FC<{
  icon: React.ReactElement;
  title: string | React.ReactElement;
  maxWidth?: string | number;
}> = ({ icon, title, maxWidth }) => {
  return (
    <div className="details-item" style={{ maxWidth }}>
      <div>{icon}</div>
      <p className="m-0">{title}</p>
    </div>
  );
};

export default EventDetailItem;
